import { systemGeneratedApplicantStatusReasonLabels, userGeneratedApplicantStatusReasonLabels } from 'data';
import { ApplicantStatusReason } from 'types';

export function getStatusReasonLabel(statusReason: string): string {
  return (
    systemGeneratedApplicantStatusReasonLabels[statusReason] ??
    userGeneratedApplicantStatusReasonLabels[statusReason] ??
    ApplicantStatusReason.Other
  );
}
